import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import ProductImageGallery from '../../components/ProductImageGallery';
import { useCart } from '../../context/CartContext';

const SUIP400Gameboy = () => {
    const navigate = useNavigate();
    const { addToCart } = useCart();
  const [activeTab, setActiveTab] = useState('overview');
  const [currentImage, setCurrentImage] = useState('');
  const [selectedColor, setSelectedColor] = useState('Black');
  const [selectedPlayer, setSelectedPlayer] = useState('Single Player');
  const [quantity, setQuantity] = useState(1);
  
  // 根据玩家模式计算价格
  const getPriceByPlayer = (player) => {
    if (player === 'Single Player') return 15.90;
    if (player === 'Double Players') return 17.90;
    return 15.90; // 默认价格
  };
  
  const currentPrice = getPriceByPlayer(selectedPlayer);
  
  // 产品数据
  const product = {
    id: 'suip-400-gameboy',
    name: 'SUP Mini Retro Console – 400-in-1 Portable Handheld Game Player',
    category: 'retro-gaming',
    price: `$${currentPrice}`,
    originalPrice: "$19.99",
    image: '/images/shop-products/suip-400-gameboy/new-cover-3.jpeg',
    description: 'Portable handheld game player with 400 built-in classic 8-bit games, featuring a 3.0-inch LCD display and rechargeable battery',
    specs: {
      "Screen": "3.0-inch LCD display",
      "Games": "400 built-in classic 8-bit games",
      "Battery": "1020mAh rechargeable lithium battery",
      "Storage": "128MB built-in",
      "Connectivity": "USB charging, AV output (wired for TV connection)",
      "Dimensions": "8 × 11.5 × 2.3 cm"
    },
    features: [
      "400 Classic 8-bit Games",
      "3.0-inch LCD Display",
      "Rechargeable Battery",
      "Portable Design",
      "TV Output Support",
      "USB Charging"
    ],
    inStock: true,
    rating: 4.6,
    reviews: 789
  };
  
  // 颜色图片映射
  const colorImages = {
    'Black': '/images/shop-products/suip-400-gameboy/screenshot-2.png',
    'Red': '/images/shop-products/suip-400-gameboy/screenshot-1.png'
  };
  
  // 更多图片
  const additionalImages = [
    '/images/shop-products/suip-400-gameboy/new-cover-3.jpeg',
    '/images/shop-products/suip-400-gameboy/screenshot-1.png',
    '/images/shop-products/suip-400-gameboy/screenshot-2.png',
    '/images/shop-products/suip-400-gameboy/screenshot-3.png',
    '/images/shop-products/suip-400-gameboy/screenshot-4.png'
  ];

  // 初始化当前图片 - 显示主图片
  useEffect(() => {
    setCurrentImage(product.image); // 显示主图片 new-cover-3.jpeg
  }, []);
  
  // 当用户主动选择颜色时切换图片
  const handleColorSelect = (colorName, colorImage) => {
    setSelectedColor(colorName);
    setCurrentImage(colorImage);
  };

  // 添加到购物车
  const handleAddToCart = () => {
    const cartItem = {
      id: product.id,
      name: product.name,
      price: currentPrice,
      image: product.image,
      quantity: quantity,
      selectedColor: selectedColor,
      selectedPlayer: selectedPlayer
    };
    addToCart(cartItem);
  };

  // 立即购买
  const handleBuyNow = () => {
    const cartItem = {
      id: product.id,
      name: product.name,
      price: currentPrice,
      image: product.image,
      quantity: quantity,
      selectedColor: selectedColor,
      selectedPlayer: selectedPlayer
    };
    addToCart(cartItem);
    navigate('/cart');
  };

  // 相关产品
  const relatedProducts = [
    {
      id: 1,
      name: "X7M Gameboy",
      price: 79.99,
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=500&h=500&fit=crop"
    },
    {
      id: 2,
      name: "Nintendo Joycon Pikachu",
      price: 89.99,
      image: "https://images.unsplash.com/photo-1598550476439-6847785fcea6?w=500&h=500&fit=crop"
    },
    {
      id: 3,
      name: "Switch Pro Controller",
      price: 69.99,
      image: "https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?w=500&h=500&fit=crop"
    },
    {
      id: 4,
              name: "Wireless Keyboard",
      price: 299.99,
      image: "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=500&h=500&fit=crop"
    }
  ];

  return (
    <div className="container mx-auto px-4 py-12 text-white">
      {/* 面包屑导航 */}
      <div className="text-sm text-gray-400 mb-6">
        <Link to="/" className="hover:text-white">Home</Link> / 
        <Link to="/shop" className="hover:text-white mx-2">Shop</Link> / 
        <Link to="/shop/retro-gaming" className="hover:text-white mr-2">Retro Gaming</Link> / 
        <span className="text-white">{product.name}</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* 左侧产品图片 */}
        <div>
          <ProductImageGallery
            images={additionalImages}
            currentImage={currentImage}
            onImageChange={setCurrentImage}
          />
        </div>
        
        {/* 右侧产品信息 */}
        <div>
          <h1 className="text-3xl font-bold mb-2">{product.name}</h1>
          
          {/* 评分 */}
          <div className="flex items-center mb-4">
            <div className="flex text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={i < Math.floor(product.rating) ? "text-yellow-400" : "text-gray-600"}>★</span>
              ))}
            </div>
            <span className="ml-2 text-gray-400">({product.reviews} reviews)</span>
          </div>
          
          {/* 价格 */}
          <div className="mb-6">
            <span className="text-3xl font-bold">${currentPrice.toFixed(2)}</span>
            {product.originalPrice && (
              <span className="ml-3 text-gray-400 line-through">{product.originalPrice}</span>
            )}
            {product.originalPrice && (
              <span className="ml-3 bg-red-600 text-white px-2 py-1 rounded-md text-sm">
                Save ${(parseFloat(product.originalPrice.replace(/^\$/, '')) - currentPrice).toFixed(2)}
              </span>
            )}
          </div>
          
          {/* 库存状态 */}
          <div className="mb-6">
            {product.inStock ? (
              <span className="text-green-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                In Stock
              </span>
            ) : (
              <span className="text-red-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                Out of Stock
              </span>
            )}
          </div>
          
          {/* 简短描述 */}
          <p className="text-gray-300 mb-6">{product.description}</p>
          
          {/* 选择颜色 */}
          <div className="mb-6">
            <h3 className="text-lg font-medium mb-3">Choose Color</h3>
            <div className="flex gap-3">
              {[
                { name: 'Black', image: '/images/shop-products/suip-400-gameboy/screenshot-2.png' },
                { name: 'Red', image: '/images/shop-products/suip-400-gameboy/screenshot-1.png' }
              ].map((color) => (
                <div key={color.name} className="flex flex-col">
                  <button 
                    className={`w-[80px] h-[80px] border ${color.name === selectedColor ? 'border-2 border-green-500' : 'border border-gray-600'} 
                      rounded-md bg-gray-800 flex items-center justify-center overflow-hidden relative`}
                    onClick={() => handleColorSelect(color.name, color.image)}
                  >
                    <div className="w-full h-full flex items-center justify-center">
                      <img 
                        src={color.image}
                        alt={color.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    {color.name === selectedColor && (
                      <div className="absolute top-0 right-0 w-0 h-0 border-t-[20px] border-r-[20px] border-t-transparent border-r-green-500"></div>
                    )}
                  </button>
                  <div className="mt-2 text-center">
                    <div className="text-sm text-white font-medium">{color.name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* 选择玩家模式 */}
          <div className="mb-6">
            <h3 className="text-lg font-medium mb-3">Player</h3>
            <div className="grid grid-cols-2 gap-3">
              {['Single Player', 'Double Players'].map((player) => (
                <button 
                  key={player}
                  className={`border-2 ${player === selectedPlayer ? 'border-green-500' : 'border-gray-700'} 
                    rounded-md py-3 px-4 text-center hover:border-green-500 transition-colors`}
                  onClick={() => setSelectedPlayer(player)}
                >
                  {player}
                </button>
              ))}
            </div>
          </div>
          
          {/* 数量 */}
          <div className="mb-8">
            <h3 className="text-lg font-medium mb-3">Quantity</h3>
            <div className="flex items-center">
              <button 
                className="bg-gray-800 px-4 py-2 rounded-l-md"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                -
              </button>
              <input 
                type="text" 
                value={quantity} 
                readOnly
                className="bg-gray-800 text-center w-16 py-2 border-x border-gray-700"
              />
              <button 
                className="bg-gray-800 px-4 py-2 rounded-r-md"
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>
          </div>
          
          {/* 购买按钮 */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <button 
              onClick={handleAddToCart}
              className="bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-md font-medium"
            >
              Add to Cart
            </button>
            <button 
              onClick={handleBuyNow}
              className="bg-gray-800 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium border border-gray-600"
            >
              Buy Now
            </button>
          </div>
          
          {/* 配送信息 */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex items-center mb-3">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2a1 1 0 00.9-.5l1.5-2A1 1 0 0015 7h-3V4a1 1 0 00-1-1H3zM14 7l-1.5 2H10V5h4v2z" />
              </svg>
              <span className="text-gray-300">Meet Up Free</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              <span className="text-gray-300">Available at Sengkang & Orchard locations</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* 产品详情选项卡 */}
      <div className="mt-16">
        <div className="border-b border-gray-700 mb-8">
          <div className="flex space-x-8">
            <button 
              onClick={() => setActiveTab('overview')}
              className={`pb-4 px-2 font-medium ${activeTab === 'overview' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Overview
            </button>
            <button 
              onClick={() => setActiveTab('specs')}
              className={`pb-4 px-2 font-medium ${activeTab === 'specs' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Specifications
            </button>
            <button 
              onClick={() => setActiveTab('reviews')}
              className={`pb-4 px-2 font-medium ${activeTab === 'reviews' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Reviews ({product.reviews})
            </button>
          </div>
        </div>
        
        {/* 选项卡内容 */}
        <div>
          {activeTab === 'overview' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Product Overview</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                  <p className="text-gray-300 mb-6">
                    The SUP Mini Retro Console brings back the nostalgia of classic handheld gaming with a modern twist. 
                    This portable game player comes pre-loaded with 400 carefully selected classic 8-bit games that defined 
                    the golden age of portable gaming, all in one compact and portable package.
                  </p>
                  <p className="text-gray-300 mb-6">
                    Featuring a vibrant 3.0-inch LCD display with crisp graphics and responsive controls, this handheld 
                    delivers the authentic retro gaming experience you remember. The 1020mAh rechargeable lithium battery 
                    provides hours of uninterrupted gaming fun, perfect for long trips, commutes, or nostalgic gaming sessions at home.
                  </p>
                  <p className="text-gray-300">
                    The device's compact design (8 × 11.5 × 2.3 cm) makes it easy to carry anywhere, while the built-in 128MB storage 
                    ensures all your favorite games are always accessible. With USB charging and AV output for TV connection, 
                    you can enjoy your games on the go or on the big screen at home.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-4">Key Features</h3>
                  <ul className="space-y-4">
                    {product.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <svg className="w-6 h-6 mr-2 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <div>
                          <span className="font-medium">{feature}</span>
                          <p className="text-gray-400 text-sm mt-1">
                            {feature === "400 Classic 8-bit Games" && "Pre-loaded with 400 carefully selected classic 8-bit games from the golden age of gaming"}
                            {feature === "3.0-inch LCD Display" && "Crisp 3.0-inch LCD display with vibrant colors and sharp graphics for the best gaming experience"}
                            {feature === "Rechargeable Battery" && "1020mAh rechargeable lithium battery provides hours of uninterrupted gaming fun"}
                            {feature === "Portable Design" && "Compact and lightweight design, easy to carry anywhere for gaming on the go"}
                            {feature === "TV Output Support" && "Connect to your TV via AV output for big-screen gaming experience"}
                            {feature === "USB Charging" && "Convenient USB charging with fast charging capability"}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
          
          {activeTab === 'specs' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Technical Specifications</h2>
              <div className="bg-gray-800 rounded-lg p-6">
                <table className="w-full">
                  <tbody>
                    {Object.entries(product.specs).map(([key, value], index) => (
                      <tr key={index} className={index !== 0 ? "border-t border-gray-700" : ""}>
                        <td className="py-4 pr-4 font-medium w-1/3">{key}</td>
                        <td className="py-4 text-gray-300">{value}</td>
                      </tr>
                    ))}
                    <tr className="border-t border-gray-700">
                      <td className="py-4 pr-4 font-medium">Dimensions</td>
                      <td className="py-4 text-gray-300">140mm x 80mm x 25mm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          
          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Customer Reviews</h2>
              <div className="flex items-center mb-8">
                <div className="mr-4">
                  <div className="text-5xl font-bold">{product.rating}</div>
                  <div className="flex text-yellow-400 mt-2">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className={i < Math.floor(product.rating) ? "text-yellow-400" : "text-gray-600"}>★</span>
                    ))}
                  </div>
                  <div className="text-sm text-gray-400 mt-1">Based on {product.reviews} reviews</div>
                </div>
                <div className="flex-1 ml-6">
                  {[5, 4, 3, 2, 1].map((star) => (
                    <div key={star} className="flex items-center mb-2">
                      <div className="w-12 text-sm text-gray-400">{star} stars</div>
                      <div className="w-full bg-gray-700 rounded-full h-2 mx-2">
                        <div 
                          className="bg-yellow-400 h-2 rounded-full" 
                          style={{ 
                            width: `${star === 5 ? 65 : star === 4 ? 25 : star === 3 ? 7 : star === 2 ? 2 : 1}%` 
                          }}
                        ></div>
                      </div>
                      <div className="w-12 text-sm text-right text-gray-400">
                        {star === 5 ? '65%' : star === 4 ? '25%' : star === 3 ? '7%' : star === 2 ? '2%' : '1%'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* 示例评论 */}
              <div className="space-y-6">
                {[
                  { name: "David R.", rating: 5, date: "1 week ago", comment: "This is exactly what I was looking for! 400 classic games in one device is incredible. The screen is bright and clear, and the battery life is impressive. I've been playing for hours and it's still going strong. Perfect for reliving my childhood gaming memories!" },
                  { name: "Sarah T.", rating: 5, date: "2 weeks ago", comment: "Bought this for my son who loves retro games and he's absolutely obsessed with it. The games load quickly and the controls are responsive. The portable design is perfect for car trips and the USB-C charging is so convenient. Great value for money!" },
                  { name: "Michael L.", rating: 4, date: "1 month ago", comment: "Solid retro gaming handheld. The game selection is excellent and the screen quality is good for the price. The only minor issue is that some games could use better button mapping, but overall it's a great device for classic gaming on the go." }
                ].map((review, index) => (
                  <div key={index} className="border-b border-gray-700 pb-6">
                    <div className="flex justify-between mb-2">
                      <span className="font-medium">{review.name}</span>
                      <span className="text-gray-400 text-sm">{review.date}</span>
                    </div>
                    <div className="flex text-yellow-400 mb-2">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className={i < review.rating ? "text-yellow-400" : "text-gray-600"}>★</span>
                      ))}
                    </div>
                    <p className="text-gray-300">{review.comment}</p>
                  </div>
                ))}
              </div>
              
              {/* 查看更多评论按钮 */}
              <div className="mt-8 text-center">
                <button className="bg-gray-800 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium">
                  Load More Reviews
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {/* 相关产品 */}
      <div className="mt-20">
        <h2 className="text-2xl font-bold mb-8">You May Also Like</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {relatedProducts.map(product => (
            <div key={product.id} className="bg-gray-800 rounded-lg overflow-hidden">
              <img src={product.image} alt={product.name} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="font-medium mb-2">{product.name}</h3>
                <div className="flex justify-between items-center">
                  <span className="font-bold">${product.price}</span>
                  <button className="bg-green-600 hover:bg-green-700 text-white py-1 px-3 rounded-md text-sm">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SUIP400Gameboy;
